// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container__aichat_menu_title[data-v-078b49ce]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:180px;display:block;cursor:pointer}.text-center[data-v-078b49ce]{text-align:center}.mt-3[data-v-078b49ce]{margin-top:1rem}", ""]);
// Exports
module.exports = exports;
